var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ServiceLayout',{attrs:{"icon":"notext-starx.png","title":"StarX","description":"Cocok untuk anda yang ingin berpergian bersama keluarga atau sahabat dengan jumlah kapasitas mulai dari 1-4 orang (hanya berlaku untuk perjalanan dalam kota).","extra_hour":1,"tariffs":_vm.starx_tariffs,"lists":_vm.starx_list}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e6ed4a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Service/StarX.vue
// module id = null
// module chunks = 